module.exports = __webpack_public_path__ + "img/preloader.4a7587de.svg";